import React, { Fragment } from 'react'

function CurrencyOptions() {
  return (
    <Fragment>
      <option value='MYR' title='Malaysian Ringgit'>MYR</option>
      <option value='AED' title='United Arab Emirates Dirham'>AED</option>
      <option value='ARS' title='Argentine Peso'>ARS</option>
      <option value='AUD' title='Australian Dollar'>AUD</option>
      <option value='BGN' title='Bulgarian Lev'>BGN</option>
      <option value='BRL' title='Brazilian Real'>BRL</option>
      <option value='BSD' title='Bahamian Dollar'>BSD</option>
      <option value='CAD' title='Canadian Dollar'>CAD</option>
      <option value='CHF' title='Swiss Franc'>CHF</option>
      <option value='CLP' title='Chilean Peso'>CLP</option>
      <option value='CNY' title='Chinese Yuan'>CNY</option>
      <option value='COP' title='Colombian Peso'>COP</option>
      <option value='CZK' title='Czech Republic Koruna'>CZK</option>
      <option value='DKK' title='Danish Krone'>DKK</option>
      <option value='DOP' title='Dominican Peso'>DOP</option>
      <option value='EGP' title='Egyptian Pound'>EGP</option>
      <option value='EUR' title='Euro'>EUR</option>
      <option value='FJD' title='Fijian Dollar'>FJD</option>
      <option value='GBP' title='British Pound Sterling'>GBP</option>
      <option value='GTQ' title='Guatemalan Quetzal'>GTQ</option>
      <option value='GYD' title='Guyanaese Dollar'>GYD</option>
      <option value='HKD' title='Hong Kong Dollar'>HKD</option>
      <option value='HRK' title='Croatian Kuna'>HRK</option>
      <option value='HUF' title='Hungarian Forint'>HUF</option>
      <option value='IDR' title='Indonesian Rupiah'>IDR</option>
      <option value='ILS' title='Israeli New Sheqel'>ILS</option>
      <option value='INR' title='Indian Rupee'>INR</option>
      <option value='ISK' title='Icelandic Króna'>ISK</option>
      <option value='JPY' title='Japanese Yen'>JPY</option>
      <option value='KRW' title='South Korean Won'>KRW</option>
      <option value='KZT' title='Kazakhstani Tenge'>KZT</option>
      <option value='MVR' title='Maldivian Rufiyaa'>MVR</option>
      <option value='MXN' title='Mexican Peso'>MXN</option>
      <option value='NOK' title='Norwegian Krone'>NOK</option>
      <option value='NZD' title='New Zealand Dollar'>NZD</option>
      <option value='PAB' title='Panamanian Balboa'>PAB</option>
      <option value='PEN' title='Peruvian Nuevo Sol'>PEN</option>
      <option value='PHP' title='Philippine Peso'>PHP</option>
      <option value='PKR' title='Pakistani Rupee'>PKR</option>
      <option value='PLN' title='Polish Zloty'>PLN</option>
      <option value='PYG' title='Paraguayan Guarani'>PYG</option>
      <option value='RON' title='Romanian Leu'>RON</option>
      <option value='RUB' title='Russian Ruble'>RUB</option>
      <option value='SAR' title='Saudi Riyal'>SAR</option>
      <option value='SEK' title='Swedish Krona'>SEK</option>
      <option value='SGD' title='Singapore Dollar'>SGD</option>
      <option value='THB' title='Thai Baht'>THB</option>
      <option value='TRY' title='Turkish Lira'>TRY</option>
      <option value='TWD' title='New Taiwan Dollar'>TWD</option>
      <option value='UAH' title='Ukrainian Hryvnia'>UAH</option>
      <option value='USD' title='United States Dollar'>USD</option>
      <option value='UYU' title='Uruguayan Peso'>UYU</option>
      <option value='ZAR' title='South African Rand'>ZAR</option>
    </Fragment>
  )
}

export default CurrencyOptions
